import http from "./HttpService";
const endpoint =
  process.env.VUE_APP_INTERVIEW_RESERVE_URL + "/api/" + "admin/rooms/";

const getRooms = (status) => {
  return http.get(endpoint + "?status=" + status, {
  });
};

const getRoom = (id) => {
  return http.get(endpoint + id, {
  });
};

const deleteRoom = (id) => {
  return http.delete(endpoint + id, {
  });
};

const changeStatus = (id, status) => {
  return http.put(
    endpoint + id.toString() + "/changeStatus",
    { status: status },
  );
};

const changeAgentId = (roomId, agentId) => {
  return http.put(
    endpoint + roomId + "/changeAgent",
    {
      agentID: agentId,
    },
  );
};

const deleteRoomRecord = (roomID, recordName) => {
  return http.delete(
    endpoint + roomID + "/deleteRecord?recordName=" + recordName,
  );
};

export default {
  getRooms,
  getRoom,
  deleteRoom,
  changeStatus,
  changeAgentId,
  deleteRoomRecord,
};
